import { Environment } from './model/Environment';

export const environment: Environment = {
    expDateMaxAttempts: 3,
    endpointSecurePassword: 'https://bdb-ao-prod-elb-apigateway-1013813835.us-east-1.elb.amazonaws.com:443/',
    apiGateway: 'https://api.bancodebogota.co/auth/',
    endpointCifin: 'https://api.bancodebogota.co/auth/',
    production: true,
    platform: 'OFFICE',
    channel: 'OFFICE',
    trustedDomains: 'https://bancodebogota.com.co',
    technicalServicePhoneNumber: '320 350 0050',

    UrlWSRnec: 'https://api.bancodebogota.co/auth/',
    authenticatorEndpointSandboxV3: 'https://api-sbx.labdigbdbsg.com/authenticator',
    mdmBusinessInfoEndpoint: 'https://api.bancodebogota.co/vivienda/mdm/mdmBusinessInfo',

    mdmBusinessInfoTVSEndpoint: 'https://api-sbx.labdigbdbsg.com/auth/V1/product/authenticator/office',

    endpointHealty: 'https://api-gateway.bancodebogota.com.co/health/fronthealth',
    codeReCaptcha: 'lmnGRFD58V6IJFed4RF9PIqgOk1AAACxRY8',
    apiEndpointEvents: 'https://pkim2hkbi5.execute-api.us-east-1.amazonaws.com/v1/',
    apiEndpointEventsReg: 'https://pkim2hkbi5.execute-api.us-east-1.amazonaws.com/v1/',
    endpointThreat: 'https://digitalid.bancodebogota.com.co/fp/tags.js?org_id=adq0fjol',
    CYPHER_JS_KEY: 'FRONTEND_CIPHER_BDB_PROD',
    publicKey: '-----BEGIN PUBLIC KEY-----' +
        'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAw0KiPRFMIHDkR40luaDj' +
        'VXXxZD7Q9zf6Iw+PnyjNKdKidiBTh9D2KZj/zFkYkYhEgq4jnBpzp/hCGz3T9XOq' +
        'Z30/sYNCKrysBg+DD4HTjMR0qZEjz7jHZLNj7joVggXSDfrIwzjuS6k9J0Kze9/K' +
        'GrdWkBo8uMTTQTjTloUUQ07z77q+hksWrQBS5HMM3GopHWN9Y6Z1PDVtAdCty8rZ' +
        'b63CibOydwTsrwBS8gBQ6+bHYFzWNfDJI3nC9Gs7eR0xb1xdnsCvC034oK+G+XMi' +
        'Q9NbKN62JVYto3yre858RdH0ZdGCZOBghY9Ctb2LcN4V7CAxs7UHqadKYGmhVJRG' +
        '2wIDAQAB' +
        '-----END PUBLIC KEY-----',
    registeredApplications: {
        '1': {
            baseUrl: 'https://saccountopen.bancodebogota.com.co/'
        },
        '2': {
            baseUrl: 'https://officehomelabdigital.bancodebogota.com.co/'
        },
        '3': {
            baseUrl: 'https://tcdigitalofficebdb.bancodebogota.com.co/#/'
        },
        '4': {
            baseUrl: ' https://abretucuenta.bancodebogota.com.co/#/'
        },
        '5': {
            baseUrl: 'https://oficinaviviendadigital.bancodebogota.co/'
        },
        '6': {
            baseUrl: 'https://virtual.bancodebogota.com.co/#/'
        },
        '7': {
            baseUrl: 'https://libranzadigital.bancodebogota.co/'
        },
        '8': {
            baseUrl: 'https://tulibranzafacil.bancodebogota.co/#/'
        },
        '10': {
            baseUrl: 'https://creditodigitaloficina.bancodebogota.co/#/'
        },
        '11': {
            baseUrl: 'https://serviciospostventa.bancodebogota.com.co/'
        },
        '12': {
            baseUrl: 'http://mantizdesarrollo.bancodebogota.net:8001/'
        },
        '15': {
            baseUrl: 'https://microdigital.bancodebogota.co/client-authenticator-handler'
        },
        '16': {
            baseUrl: 'https://ofertadeseguros.bancodebogota.com'
        },
        '17': {
            baseUrl: 'https://cdt.bancodebogota.co/'
        },
        '23': {
            baseUrl: 'https://microrotativo.bancodebogota.com.co/'
        },
        '28': {
            baseUrl: 'https://tcdigital.bancodebogota.co/office-card/'
        },
        '36': {
            baseUrl: 'https://caccountopen.bancodebogota.com.co/'
        },
        '40': {
            baseUrl: 'https://creditovehiculo.bancodebogota.com/form-user/'
        },
        '42': {
            baseUrl: 'https://crediconveniodigital.bancodebogota.com.co/'
        },
        '43': {
            baseUrl: 'https://fidubogota.bancodebogota.com.co/'
        },
        '47': {
            baseUrl: 'https://compradecartera.bancodebogota.com.co/'
        }
    },
    enableGeolocationModal: true,
    tagManagerGoogle: 'GTM-T7Q3VZZ',
    productInfoLambdaUrl: 'https://11sbnnkow2.execute-api.us-east-1.amazonaws.com/prod/product-by-site',
    fairApi: 'https://api.bancodebogota.co/creditcard',
    endpointAdviser: 'https://api.bancodebogota.co/auth',
    enableAuthAdviser: true,
    endpointMdM: 'https://api.bancodebogota.co/vivienda/mdm/',
    rnecMediumTypes: '1,3',
    rnecForceTwoHitsEnabled: true,
    mediumTypesOTP: '10',
    mediumTypesAdviser: '3,4,6',
    otpValidationTime: '180', // time in seconds
    otpForwardingAttempts: '2',
    mantizUrlMediumTypes: '3',
    smsOption: true,
    whatsappOption: false,
    callOption: true,
    recognitionEndpoint: 'https://api.bancodebogota.co/auth/authentication/recognition',
    recognitionEndpointSandbox: 'https://api-sbx.labdigitalbdb.co/auth/authentication/recognition',
    livenessEndpoint: 'https://api.bancodebogota.co/auth/authentication/recognition',
    olimpiaEndpoint: 'agregar cuando se cree el api de olimpia en produccion',
    olimpiaEndpointSanbox: 'https://api-sbx.labdigitalbdb.co/prod-api/olimpia',
    authenticatorV2Endpoint: 'https://api.bancodebogota.co/auth2/V1/product/authenticator',
    landingAuthenticatorOffice: 'https://authenticator.bancodebogota.com.co/',
    useConfronta: true,
    useSecurePassword: true,
    useDebitCardPassword: true,
    useToken: true,
    authenticatorEndpoint: 'https://api.bancodebogota.co/auth',
    authenticatorEndpointSandbox: 'https://api-sbx.labdigitalbdb.co/auth',
    cifinEndpoint: 'https://api.bancodebogota.co/auth/authentication/cifin',
    maxConfrontaAttempts: 3,
    useSecondFactor: true,
    mediumTypesSecondFactor: '1,2,3,4,5,6',
    siteSecondFactor: '11',
    launcherEndpoint: 'https://officehomelabdigital.bancodebogota.com.co/fair',
    dissuasiveFacialRecognition: true,
    faceRecognitionManagementEndpoint: 'https://api.bancodebogota.co/face-recognition',
    authManagerV2EndpointSandbox: 'https://api-sbx.labdigitalbdb.co/auth2',
    isEnableControlAdviser: true,
    useMDMTVSEndpoint: true,
    useSandboxV3ToRNEC: true,
    useSandboxV3ToCheckVersion: true,
    validateSecureKeyUseSandboxV3: true,
    validateDebitCardKeyUseSandboxV3: true,
    whitHandlerOffice: true,
    alertTimeoutSession: 60,
    pagesWithoutInactivity: [''],
    timeoutSession: 180,
    timeSanboxMethod: 30000,
    propertiesSandbox: {
        Parameters: { Time: 2, Body: 0, Iv: 1, Pk1: 3, Pk2: 10, Total: 12 },
        Expiration: { Time: 9999, Unit: 'minutes' },
    },
    sandbox: {
        pk: 'MTUxLDM5LDE3OSwxMzksNzEsMjM4LDE0NSwyMDUsNjQsNTUsMTI3LDM3LDE2MywyMTYsMTgyLDI0OSwyMDUsMjQsMzksMTc4LDc5LDEsMjIsMjEsNjcsMTAxLDExNiwyMzQsMjE3LDExOSwyNDYsMjI=',
        sk: 'NjIsODksMjA2LDE4NSwxNzIsMCwxNzcsMTczLDQwLDcwLDYsMTMzLDIxOSwyMSwxNDgsMjEzLDE4Niw4OSwxOTksMjU1LDI3LDIxNiwyNDksODksMTY3LDQ4LDIyOSw1MCwxOTQsNzAsMzksMTg4'
    },
    sandboxV3Domain: 'https://api-sbx.labdigbdbsg.com',
    callSingleSessionIntervalMs: 30000,
    enableNewAddSeller: true,
    enableParticipantStateIAC: false,
    enableCheckAbstentionListIAC: false,
    bffAuthMngrEnpoint: 'https://api-sbx-authdigital.labdigbdbsg.com/auth/v2',
    getPublicIpEndpoint: 'https://api.ipify.org?format=json'
};



// WEBPACK FOOTER //
// ./environments/environment.ts